import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
import { TweenMax } from 'gsap';
import EFVideo from '@/components/UI/EFVideo';

export default function C() {
    const { useEffect, useLang } = useGlobal();
    const { t } = useLang('xstream');

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        new ScrollMagic.Scene({
            triggerElement: '.xstream .section-4 .title',
            triggerHook: 1,
            offset: 200,
            duration: 200,
        })
            .setTween(TweenMax.to('.xstream .section-4 .title', 0.5, { opacity: 1 }))
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: '.xstream .section-4 .desc',
            triggerHook: 1,
            offset: 150,
            duration: 200,
        })
            .setTween(TweenMax.to('.xstream .section-4 .desc', 0.5, { opacity: 1 }))
            .addTo(controller);
    }, []);

    return (
        <div className={`xstream_C ${css.xstream_C}`}>
            <div className="section-4">
                <div className="sticky-viewport">
                    <div className="content-wrapper">
                        <EFVideo className="video" sources={['/media/x-stream/pc/04.webm', '/media/x-stream/pc/04.mp4']} />
                        <div className="mask"></div>
                        <div className="text-wrapper">
                            <div className="title">{t('section_4_title')}</div>
                            <div className="desc">{t('section_4_desc')}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
